function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_37",
  "data-name": "Pfad 37",
  d: "M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1ZM9.925,15.7a1.2,1.2,0,1,1,0-2.4,1.142,1.142,0,0,1,1.241,1.191A1.154,1.154,0,0,1,9.925,15.7Zm.906-5.383-.05,1.694H9.069L9.036,9.48c2.2-.268,3.053-.872,3.053-2.029,0-.956-.672-1.577-2.081-1.577a2.189,2.189,0,0,0-2.348,2.1L6,7.182C6.335,5.488,7.744,4.3,10.126,4.3,12.39,4.3,14,5.337,14,7.2,14,9.212,12.591,10.134,10.831,10.319Z",
  transform: "translate(-1 -1)",
  fill: "gray"
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.27535616.svg";
export { ForwardRef as ReactComponent };